import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { domainModel } from 'src/app/models/domain/domain.model';
import { TableRowUnSelectEvent } from 'primeng/table';


@Component({
    selector: 'app-support-domain-view',
    templateUrl: './support-domain-view.component.html',
    styleUrls: ['./support-domain-view.component.scss'],
    standalone: false
})
export class SupportDomainViewComponent implements OnInit{

  domainList!: domainModel[];
  loadingDomains: boolean = true;
  selectedDomain: domainModel[] = [];

    constructor(
        private AdminService: AdminService,
    ) {}


  ngOnInit() {

    this.AdminService.getAllDomainsV2().subscribe((result: any) => {

      this.domainList = result.items.map((item: any) => ({
        domainId: item['idDomain'], // Accessing property with bracket notation
        token: item['Token'],
        type: item['type'],
        api: item['enableAPI'],
        invoiceCredits: item['credit_limit'],
        invoices: item['enableInvoices'],
        plenionB2C: item['plenionB2C'],
        plenionWebServices: item['plenionWebServices'],
        portal: item['enablePortal'],
        userPermissions: item['userPermissions'],
      })); 

      this.loadingDomains = false;
    })
  };

  onRowSelect(event: any) {
    let myURL = window.location.origin;
		this.AdminService.redirectToDomain(event.data.domainId).subscribe((result: any) => {
      let targetURL = myURL + '/login?idToken=' + result['token'] + '&idDomain=' + event.data.domainId + '&site=adportal';
      window.open(targetURL, '_blank');
    });
  }

  onRowUnselect($event: TableRowUnSelectEvent<any>) {} 
}
